import { HorizontalSafeAreaContainer } from '../../../components';
import { useHorizontalSafeAreaHeaderOptions } from '../../../hooks';
import { ReorderConflictReviewScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  useHorizontalSafeAreaHeaderOptions();

  return (
    <HorizontalSafeAreaContainer>
      <ReorderConflictReviewScreen />
    </HorizontalSafeAreaContainer>
  );
}
